<template>
  <div class="page page-contacts">
    <div
      class="page__wrap p-top-xxxl-1 p-bottom-xxxl-1"
      data-animate="page-wrap"
    >
      <div>
        <PagesCommonTextHeader
          v-if="page"
          :title="page.title"
          :subtitle="page.introText"
        />

        <div data-animate="preloader-opacity" class="row-190-40">
          <section class="p-top-l-1">
            <ContactFormGestionale
              :intro="page.formIntro"
              :title="page.formTitle"
              :cta-label="page.formCtaLabel"
              :contacts-list="page.contactsList"
            />
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import queries from '@/graphql/dato/queries/index.js'
import pageTransition from '@/assets/js/transitions/helper.js'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

definePageMeta({
  layout: 'default',
  pageTransition,
})

const { locale } = useI18n()

const query = queries.corporates.getContactsPage
const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(query, variables)

if (!data.value?.contactsPage) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data.value?.contactsPage)
const seo = computed(() => data.value?.contactsPage?.seo || {})

// Seo
useSeo({
  ...seo.value,
})

onMounted(() => {
  setTimeout(() => {
    ScrollTrigger.refresh()
  }, 800)
})
</script>
